import { type Filter } from "@garimpa/lib/facetFilter";
import { releaseSearchFilterToFilter, type ReleaseSearchFilter } from "@garimpa/lib/searchState";

import type { SearchFilters } from "./use-search-state";

function searchYearFilter(
  yearFrom: number | undefined,
  yearTo: number | undefined,
): ReleaseSearchFilter["year"] {
  if (yearFrom == null && yearTo == null) return undefined;
  if (yearFrom != null && yearFrom === yearTo) return [yearFrom];
  return [yearFrom ?? null, yearTo ?? null];
}

/** Builds the shared grouped-release filter used by remote facet searches. */
export function searchPageFacetFilter(filters: SearchFilters): Filter | undefined {
  return releaseSearchFilterToFilter({
    format: filters.format,
    type: filters.type,
    genre: filters.genre,
    style: filters.style,
    country: filters.country,
    artist: { country: filters.origin },
    label: filters.label.length ? { all: filters.label } : undefined,
    company: filters.company.length ? { all: filters.company } : undefined,
    year: searchYearFilter(filters.yearFrom, filters.yearTo),
  });
}
